module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ea89b5751c155bad2e6e7b766c048beb.png";